import { useCallback, useContext } from "react";

import { AppContext } from "App";

/**
 * Hook for managing drawer state
 */
export const useDrawer = () => {
  const { globalDispatch } = useContext(AppContext);

  const handleDrawerClose = useCallback(() => {
    globalDispatch({
      type: "update",
      payload: {
        key: "isMenuOpen",
        value: false,
      },
    });
  }, [globalDispatch]);

  const handleDrawerOpen = useCallback(() => {
    globalDispatch({
      type: "update",
      payload: {
        key: "isMenuOpen",
        value: true,
      },
    });
  }, [globalDispatch]);

  return {
    handleDrawerClose,
    handleDrawerOpen,
  };
};
